import { useTeamsOptions } from '@/hooks/selectOptions/useTeamsOptions'
import Button from '../common/Button'
import Modal from '../common/Modal'
import SelectBoxAsynk from '../common/SelectBoxAsynk'
import { useState } from 'react'
import { useUpdateTeamMutation } from '@/services/tenant/teamManagement'
import { toast } from 'react-toastify'
import { useWorkGroupOptions } from '@/hooks/selectOptions/useWorkGroupOptions'
import { useUpdateWorkGroupsMutation } from '@/services/tenant/workGroups'

interface IAddToWorkGroupModalProps {
    isOpen: boolean
    onClose: () => void
    userId: string | number | null
}

const AddToWorkGroup = ({
    isOpen,
    onClose,
    userId,
}: IAddToWorkGroupModalProps) => {
    const { loadOptionsWorkGroup, WorkGroupData } = useWorkGroupOptions()
    const [updateWorkGroup] = useUpdateWorkGroupsMutation()
    const [selectedGroup, setSelectedGroup] = useState<number | null>(null)
    const handelClose = () => {
        onClose()
    }

    const onSubmit = async () => {
        if (!selectedGroup || !userId) return
        const findSelectedGroup = WorkGroupData?.data.find(
            group => group?.id === +selectedGroup,
        )
        const usersData =
            findSelectedGroup?.groupMembers?.map(member => member.id) || []

        const formData = {
            members: usersData?.includes(Number(userId))
                ? usersData
                : [...usersData, Number(userId)],
        }

        const res = await updateWorkGroup({
            groupId: selectedGroup,
            body: formData,
        }).unwrap()

        if (res?.success) {
            handelClose()
        } else {
            toast.error(
                res?.errors?.[0]?.msg || res?.message || 'Something went wrong',
            )
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={handelClose}
            title={'Add to WorkGroup'}
        >
            <div className="modal__body p-0">
                <div className="custom-form">
                    <div className="custom-form-body">
                        <div className="row gutters-16">
                            <div className="col-12">
                                <SelectBoxAsynk
                                    wrapperClassName="input--lg select-secondary select-left-spase-0"
                                    fetchFunk={loadOptionsWorkGroup}
                                    placeholder={'Select WorkGroup'}
                                    isClearable
                                    onChange={option => {
                                        setSelectedGroup(option?.value)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-footer justify-end">
                        <div className="flex-group flex-group--xs">
                            <Button
                                type="button"
                                onClick={onSubmit}
                                size="lg"
                                variant="primary-gradient"
                                disabled={!selectedGroup}
                            >
                                <span>Save Changes</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default AddToWorkGroup
